import { useQuery } from '@tanstack/react-query';
import { api } from 'constants/api';

import { ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

type EncodingRangeValue = {
  credit_value: number;
  range_from: number;
  range_to: number;
};
export type ReferenceTable = {
  encoding: 'GSM-7' | 'UCS-2';
  data: EncodingRangeValue[];
};

export type ReferenceTablesResponseType = ReferenceTable[];

export const useGetReferenceTables = (
  options: QueryOptions<ReferenceTablesResponseType> = {}
) =>
  useQuery({
    queryFn: async (): Promise<ReferenceTablesResponseType> => {
      const { data } = await api.get<ApiResponse<ReferenceTablesResponseType>>(
        `/campaign/reference-tables`
      );

      return data.data;
    },
    queryKey: ['reference-tables'],
    ...options,
  });
